/**
 * `?volgende=` na inloggen/registreren. Alleen interne paden: geen `//host`,
 * geen schema en geen backslashes, anders is het een open redirect.
 */
export function safeNextPath(value: string | null): string | null {
  if (!value || !value.startsWith('/') || value.startsWith('//')) return null;
  if (value.includes('\\') || [...value].some((c) => c.charCodeAt(0) < 0x20)) return null;
  return value;
}

export const isInvitationPath = (path: string | null) => path?.startsWith('/uitnodiging/') ?? false;

/** Querystring die `volgende` doorgeeft tussen inloggen en registreren. */
export const nextQuery = (next: string | null) =>
  next ? `?volgende=${encodeURIComponent(next)}` : '';
